import { PublicApiKeyFormValues, PublicApiSettings } from "./types";

export const PUBLIC_API_KEY_NAME_MAX_LENGTH = 100;

export const INITIAL_PUBLIC_API_KEY_FORM_VALUES: PublicApiKeyFormValues = {
  name: "",
  expiresAt: null,
};

export const INITIAL_PUBLIC_API_SETTINGS: PublicApiSettings = {
  enabled: false,
  maxKeys: 10,
  keys: [],
};
